// src/services/pedidos/TaxaEntregaBairroService.js
import { deleteData, fetchData, postData, putData } from '../Api';
import { parseNumeric } from '../../utils/numberUtils';

const prepararPayload = (taxa) => ({
  ...taxa,
  // O município permanece fixo enquanto sua seleção estiver oculta no cadastro.
  cidadeId: 1,
  valor: parseNumeric(taxa.valor),
});

export const buscarTaxasEntregaBairro = async () => await fetchData('/TaxaEntregaBairro');
export const adicionarTaxaEntregaBairro = async (taxa) => await postData('/TaxaEntregaBairro', prepararPayload(taxa));
export const alterarTaxaEntregaBairro = async (taxa) => await putData('/TaxaEntregaBairro', prepararPayload(taxa));
export const excluirTaxaEntregaBairro = async (id) => await deleteData('/TaxaEntregaBairro', { taxaEntregaBairroId: id });
